import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { sosTime } from "./sosAlertRules";

/**
 * The live SOS popup: a red card at the top that stays until closed, with each new SOS's title and message (newest first),
 * Mute / Unmute of the alarm, Open SOS alerts (/notification › SOS alerts, same tab) and Close.
 */
export default function SosAlertPopup({ alerts, muted, onMute, onClose }) {
  const closeRef = useRef(null);
  const count = alerts.length;

  useEffect(() => {
    if (count && closeRef.current) closeRef.current.focus();
  }, [count]);

  if (!count) return null;
  return (
    <div className="sos-alert" role="alertdialog" aria-modal="false" aria-labelledby="sos-alert-title" aria-describedby="sos-alert-list">
      <header className="sos-alert__head">
        <i className="fas fa-exclamation-triangle" aria-hidden="true" />
        <h2 id="sos-alert-title">SOS ALERT{count > 1 ? ` · ${count}` : ""}</h2>
        <span className="sos-alert__time">{sosTime(alerts[0].entryTime)}</span>
      </header>
      <ul className="sos-alert__list" id="sos-alert-list">
        {alerts.map((a) => (
          <li key={a.id}>
            <strong>{a.title || "SOS"}</strong>
            <p>{a.message}</p>
            {count > 1 && <small>{sosTime(a.entryTime)}</small>}
          </li>
        ))}
      </ul>
      <footer className="sos-alert__foot">
        <button type="button" className="btn btn-link btn-sm sos-alert__mute" onClick={onMute}>
          <i className={`fas fa-volume-${muted ? "up" : "mute"}`} aria-hidden="true" /> {muted ? "Unmute sound" : "Mute sound"}
        </button>
        <Link to="/notification?tab=sos" className="btn btn-sm sos-alert__open" onClick={onClose}>
          <i className="fas fa-list" aria-hidden="true" /> Open SOS alerts
        </Link>
        <button type="button" ref={closeRef} className="btn btn-sm sos-alert__close" onClick={onClose}>
          Close
        </button>
      </footer>
    </div>
  );
}
